import { useContext } from 'react';
import { EoeLoginPage } from '../../../../components/EoeLoginPage/EoeLoginPage.js';
import { initiateElisaIdV2Login } from '../../../common/util/elisaIdLogin.js';
import { useAuth } from '../../AuthProvider';
import { SiteContext } from '../../SiteContext.js';

export const EoeLoginPath = () => {
  const { siteLanguage } = useContext(SiteContext);
  const { prepareElisaIdLogin, elisaIdV3Enabled } = useAuth();
  return (
    <div id="elisaid-login-form-parent" className="of-employee__employee-portal-home">
      <EoeLoginPage
        initiateLogin={() =>
          elisaIdV3Enabled ? prepareElisaIdLogin() : initiateElisaIdV2Login(siteLanguage.substring(0, 2))
        }
      />
    </div>
  );
};
